import * as React from 'react';
import {Input,showCustomDialog, showErrorDialog, showSuccessDialog,closeDialog,showLoading,Form,Button
, Label, Util} from 'baziigram';
import {navigate} from 'gatsby'
import GamePageLayout from '../../components/GamePageLayout';
import appService from '../../Service';
import {useSelector, useDispatch} from 'react-redux'
import {persist} from "../../redux/actions"
import GameNavbar from "../../components/GameNavbar";
import GameHeader from "../../components/GameHeader";
import {useForm} from "react-hook-form";
import  "./styles.css";
import {dictionary} from "../../constants"
import {profileDictionary} from "../../constants/profile.js"
import {
    GAME_USER_PROFILE_ACTION_CLEAR,
    GAME_USER_PROFILE_ACTION_PERSIST
} from "../../redux/GameUserProfile/gameUserProfile.constant";
import {useEffect} from "react";
import  {STORAGE_KEY} from "../../constants";
import gameanalytics from "gameanalytics";
import EditDialog , {showEditDialog} from './EditDialog'
import {UpdateUser , GetUser} from "../../Util/user"

const GameUserProfile = () => {


    const {formData , user , error , prizes} = useSelector(state =>  state.gameUserProfile)
    const [language , setLanguage] = React.useState("en")
    const [className , setClassName] = React.useState("ltr text-left")
    React.useEffect(()=>{
    setLanguage(Util.getLanguage())
    if(language == "fa")
    setClassName("rtl text-right")
    },[language])

    const dispatch = useDispatch();

    const updateState = (state) => {
        dispatch(persist(state, GAME_USER_PROFILE_ACTION_PERSIST))
    }

    const clearState = (state) => {
            dispatch(persist(state, GAME_USER_PROFILE_ACTION_CLEAR))
        }

    useEffect(()=>{
    clearState()
        let u = GetUser()
        if(u)
       updateState({formData:{name:u.name,logo:u.logo},user:u})

       getUserPrizes()
    },[])

    useEffect(()=>{
        if(typeof window !== `undefined`) {
            var gameanalytics = require('gameanalytics');
            gameanalytics.GameAnalytics.initialize("712c556d47699b5e1d7beb4e004716cc",
                "7838a8d082e4769dc7ddf99ea1f07fd3ab83322a");
            let user = JSON.parse(Util.Storage.get(STORAGE_KEY.GAME_USER))
            gameanalytics.GameAnalytics.addDesignEvent("profile", 2, user);
        }
    },[])

    const getUserProfile=()=>{
        showLoading(true);
        appService
            .GetGameUserProfile()
            .then(res => {
            UpdateUser(res)

            })
            .catch(err => {
            UpdateUser({logo:formData.logo,name:formData.name})
             })
            .finally(res => {
                showLoading(false);
            });
    }

    const getUserPrizes=()=>{
    updateState({error:null})
            appService
                .GetUserPrizes()
                .then(res => {
               updateState({error:null , prizes:res.list})
                })
                .catch(err => {
                  updateState({error:err.message})
                     })
    }



const goToPage=(link)=>{
if(link.indexOf("http")>-1)
navigate("/WebView",{state:{url:link}})

else
window.open(link)

}
const scrollToProfile=()=>{
try{
document.getElementById('profile-container').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
}
catch(err){}
}

    return (
        <GamePageLayout type={GAME_USER_PROFILE_ACTION_CLEAR}>
        <EditDialog language={language}/>
            <GameNavbar/>
            <GameHeader type={GAME_USER_PROFILE_ACTION_CLEAR}>
            <div className={"p-3 text-center d-flex flex-column justify-content-center align-items-center"}>
             <div  dangerouslySetInnerHTML={{__html: dictionary.profileHeader[language]}} />
             <Button onClick={scrollToProfile} title={dictionary.seeProfile[language]}></Button>
            </div>
            </GameHeader>
{user && <><div id="profile-container"  className={`${className} d-flex flex-column justify-content-between align-items-start profile-container my-4`}>
<div  className={"rtl d-flex flex-row justify-content-start align-items-center w-100"}>
<img style={{display:"block"}} width={"70px"} height={"70px"} className={"mx-2"} src={`/images/profileImages/${formData.logo}.png`}/>
<div  className={"rtl d-flex flex-column justify-content-start align-items-start mr-2"}>
<div>{formData.name}</div>
{user.coins && <div className={`my-2   w-100 ${className} text-center`}>
{profileDictionary.myPhoecoins[language]}:
<span className={"mr-2"}>{user.coins}</span>
<img className="mr-2" src={"/images/icons/coin2.png"} width={"22px"}/>
</div>}
</div>
</div>
<Button onClick={showEditDialog}  title={profileDictionary.editProfile[language]}/>
<br/><br/>
<h1 style={{borderBottom:"3px solid #b848f0"}} className="mt-4 pb-3">{profileDictionary.awardHistory[language]}</h1>
{ error==null && prizes==null  && <div
  className={`baziigram-spinner my-5 spinner-border text-light`}
  role="status"
    ></div>}
   {error && <div className={"text-center text-warning w-100"}>{error}
      <Button onClick={getUserPrizes} className={"mt-3"} title={dictionary.retry[language]}/>
      </div>}
{
prizes && prizes.length>0 && prizes.map(prize=>{
return <div className="d-flex flex-column justify-content-between my-2 prize-item" >
<div className="d-flex flex-row justify-content-start  align-items-center">
{prize.logo && <img style={{display:"block"}} width={"60px"} height={"60px"} className={"mx-2"}
 src={prize.logo}/>
}
{(prize.logo==null || prize.logo=="")  && <img style={{display:"block"}} width={"60px"} height={"60px"} className={"mx-2"}
 src={"/images/icons/gift-default.png"}/>
}
<div className="d-flex flex-column justify-content-start mr-2">
<h3>{prize.companyName}</h3>
{prize.category!="charge" && prize.code!="" && prize.code!=null  && <div className="rtl my-1">{profileDictionary.discountCode[language]} : {prize.code}</div>}
{prize.category=="charge" && prize.code!="" && prize.code!=null  && <div className="rtl my-1">{profileDictionary.pinCharge[language]} : {prize.code}</div>}
{prize.expireDate && prize.expireDate !="" && <div className="text-warning" style={{fontSize:"0.9"}}> {profileDictionary.expDate[language]} : {prize.expireDate}</div>}
<div style={{fontSize:"0.8" , color:"#d4c5db"}} >{prize.description}</div>
</div>
</div>
{prize.link && prize.link!="" && <Button onClick={()=>goToPage(prize.link)} className="full-width-btn my-2" title={profileDictionary.purchase[language]}/>}
</div>
})

}


</div></>}
        </GamePageLayout>
    );
};

export default GameUserProfile;
